import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import { PersistGate } from 'redux-persist/integration/react';
import { Suspense } from 'react';
import { Toaster } from 'react-hot-toast';
import MainRoute from './Routes/route';
import { RouterProvider } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const GOOGLE_CLIENT_ID_FALLBACK = "missing-google-client-id";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
   <GoogleOAuthProvider clientId={CLIENT_ID || GOOGLE_CLIENT_ID_FALLBACK}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense>
          <Toaster toastOptions={{ duration: 5000 }} />
          <RouterProvider router={MainRoute} />
        </Suspense>
      </PersistGate>
    </Provider>
    </GoogleOAuthProvider>
  // </React.StrictMode>
);

reportWebVitals();
